import * as React from 'react';
import { tag } from '../../../../model/tag';
import { ListItem, ListItemIcon, ListItemText, withStyles } from '@material-ui/core';
import { Category } from '../../../../ui-components/Icons';
import { styles } from './styles';
import { StyledComponentProps } from '@material-ui/core/styles';

export interface ITagProps extends StyledComponentProps {
    tag: tag;
}
const Tag = (props: ITagProps) => {
    let name: string = '';
    if (props.tag && props.tag.description) {
        name = props.tag.description
    };
    return (<ListItem key={props.tag.code} className={props.classes.root} button>
        <ListItemIcon style={{ color: props.tag.color }} className={props.classes.iconContainer}>
            <Category className={props.classes.icon} style={{ fill: props.tag.color }} />
        </ListItemIcon>
        <ListItemText color="textSecondary" primary={name} className={props.classes.text} style={{ color: props.tag.color }} />
    </ListItem>
    );
}

export default withStyles(styles)(Tag)